(function ($) {
  Drupal.behaviors.livingAvedaArticleShareV1 = {
    attach: function (context) {
      var $module = $('.js-la-share--v1', context);

      if (!$module.length) {
        return;
      }

      var turnRelativeToAbsolute = function (urlToFix) {
        if (_.isEmpty(urlToFix)) {
          return;
        }
        // If the first URL is a backslash, the URL is relative and Pinterest won't pull it. We need to make this a full URL.
        if (urlToFix.substr(0, 1) === '/') {
          // Split the URL by backslashes
          var urlArray = location.href.split('/');
          // Find the web protocol i.e. http, https
          var protocol = urlArray[0];
          // We know there is always 2 backslashes before the website URL
          // Put the protocol and the base url together
          var websiteUrl = protocol + '//' + urlArray[2];

          // Now add the base url to the relative image url to make it absolute
          urlToFix = websiteUrl + urlToFix;
        }

        return urlToFix;
      };

      $('.js-la-share-link', $module).each(function () {
        // Find an image thats in the blog article
        var imageUrl = turnRelativeToAbsolute($module.parents('.la-article-formatter').find('picture img.lazyload').eq(0).data('src'));
        var message = !_.isEmpty($module.data('message')) ? encodeURIComponent($module.data('message')) : '';
        var $shareContainer = $(this).parent('.js-la-share--v1');
        var $customizeShare = $shareContainer.next('.js-custom-social-share');
        var openUrl = encodeURIComponent(window.location.href);
        var title = '';

        // Customize Social Share Messages and image
        if ($customizeShare.length > 0) {
          var $shareUrl = $customizeShare.attr('data-share-link');
          var $shareImage = $customizeShare.attr('data-share-image');
          var $shareHeadLine = $customizeShare.attr('data-share-headline');
          var $shareDescription = $customizeShare.attr('data-share-description');

          imageUrl = $shareImage !== null && $shareImage !== undefined && $shareImage !== '' ? turnRelativeToAbsolute($shareImage) : imageUrl;
          openUrl = $shareUrl !== null && $shareUrl !== undefined && $shareUrl !== '' ? encodeURIComponent($shareUrl) : openUrl;
          var $fbShareUrl = openUrl;

          message = $shareDescription !== null && $shareDescription !== undefined && $shareDescription !== '' ? $shareDescription : message;
          var $fbShareMsg = message;

          message = encodeURIComponent(message);
          title = $shareHeadLine !== null && $shareHeadLine !== undefined && $shareHeadLine !== '' ? $shareHeadLine : '';
          var $fbShareHeadLine = title;

          title = encodeURIComponent(title);
          if ($(this).hasClass('js-la-share-link--pinterest') || $(this).hasClass('js-la-share-link--twitter')) {
            message = title + ' ' + message;
          }
          if ($(this).hasClass('js-la-share-link--email')) {
            $(this).attr('data-subject', title);
            $(this).attr('data-body', message);
          }
          if ($(this).hasClass('js-la-share-link--facebook')) {
            $(this).addClass('customize-fb-share');
            $(this).on('click', function (event) {
              if (typeof FB !== 'undefined') {
                event.preventDefault();
                FB.ui({
                  method: 'share_open_graph',
                  action_type: 'og.shares',
                  action_properties: JSON.stringify({
                    object: {
                      'og:url': $fbShareUrl,
                      'og:title': $fbShareHeadLine,
                      'og:description': $fbShareMsg,
                      'og:image': imageUrl
                    }
                  })
                });
              }
            });
          }
        }
        if ($(this).hasClass('js-la-share-link--pinterest')) {
          var pinterestMedia = !_.isUndefined(imageUrl) && !_.isEmpty(imageUrl) ? '&media=' + imageUrl : '';

          openUrl = 'http://pinterest.com/pin/create/link/?url=' + openUrl + pinterestMedia + '&description=' + message;
        } else if ($(this).hasClass('js-la-share-link--facebook')) {
          openUrl = 'http://www.facebook.com/sharer/sharer.php?u=' + openUrl;
        } else if ($(this).hasClass('js-la-share-link--twitter')) {
          openUrl = 'http://twitter.com/share?url=' + openUrl + '&text=' + message;
        } else if ($(this).hasClass('js-la-share-link--email')) {
          var emailSubject = $(this).data('subject');

          emailSubject = !_.isUndefined(emailSubject) ? '&subject=' + emailSubject : '';
          var emailMessage = !_.isEmpty($(this).data('body')) ? $(this).data('body') : '';

          openUrl = 'mailto:?body=' + emailMessage + '%0D%0A' + openUrl + emailSubject;
        }
        $(this).attr('href', openUrl);
      });
      // We don't want to handle the mailto: link
      $('.js-la-share-link--email').removeClass('js-la-share-link');

      $('.js-la-share-link', $module).on('click', function (event) {
        if ($(this).hasClass('customize-fb-share') && typeof FB !== 'undefined') {
          return;
        }
        var width = 600;
        var height = 350;
        var openUrl = $(this).attr('href');
        // Allow for borders.
        var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
        // Allow for title and status bars.
        var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
        var windowFeatures = 'status=no,height=' + height + ',width=' + width;

        windowFeatures += ',resizable=yes,left=' + leftPosition + ',top=' + topPosition;
        windowFeatures += ',screenX=' + leftPosition + ',screenY=' + topPosition;
        windowFeatures += ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';
        window.open(openUrl, 'sharer', windowFeatures);
        event.preventDefault();
      });
    }
  };
})(jQuery);
